<div class="container">
  <div class="row card">
    <div class="main col-md-12 d-flex flex-column align-items-center card-body">
      <h1 class="title mb-3">Step 2 — How to Get Started</h1>
      <p class="fs-6">
        Getting started is easy! How easy? Watch the video below to find out!
      </p>

      <div
        class="embed-responsive embed-responsive-16by9 col-12 col-md-10 col-lg-8 my-4">
        <iframe
          class="embed-responsive-item col-12"
          height="400"
          allowfullscreen="allowfullscreen"
          src="https://www.youtube.com/embed/quzC_67NE5I?autoplay=0&rel=0&loop=1&showinfo=0&modestbranding=1"></iframe>
      </div>
      <div class="col-12">
        <ul
          ngbNav
          #customNav="ngbNav"
          class="nav-tabs nav-tabs-custom nav-justified">
          <li [ngbNavItem]="1">
            <a ngbNavLink class="text-uppercase"> Guide </a>
            <ng-template ngbNavContent>
              <ng-template [ngTemplateOutlet]="guideTwo"> </ng-template>
            </ng-template>
          </li>

          <li [ngbNavItem]="2">
            <a ngbNavLink class="text-uppercase"> Resources </a>
            <ng-template ngbNavContent>
              <ng-template [ngTemplateOutlet]="resourceTwo"> </ng-template>
            </ng-template>
          </li>
        </ul>

        <div [ngbNavOutlet]="customNav"></div>
      </div>
    </div>
  </div>
</div>
<ng-template #guideTwo>
  <app-guide-two></app-guide-two>
</ng-template>

<ng-template #resourceTwo>
  <app-resource-two></app-resource-two>
</ng-template>
